export function normalizeViewsCount(value: unknown, fallback = 0) {
	const count = Number(value);
	if (!Number.isFinite(count)) return Math.max(0, Math.trunc(fallback));
	return Math.max(0, Math.trunc(count));
}

export function formatViews(count: number) {
	const suffix = count === 1 ? "view" : "views";
	return `${new Intl.NumberFormat("en-US").format(count)} ${suffix}`;
}
